<template>


    <v-container fluid grid-list-md v-if="dataExists">

        <v-layout row wrap>

        <v-flex xs12>
           <v-alert type="success" dismissible v-model="alert1">
                {{ message }}
           </v-alert>
           <v-alert type="error" dismissible v-model="alert2">
                {{ error }}
           </v-alert>
        </v-flex>

          <!--v-flex xs12>
            <v-breadcrumbs large>
              <v-breadcrumbs-item>QQQ{{currentJsonFile.curriculum}}</v-breadcrumbs-item>
              <v-breadcrumbs-item>{{currentJsonFile.id}}</v-breadcrumbs-item>
              <template v-slot:divider>
                <v-icon>forward</v-icon>
              </template>
            </v-breadcrumbs>
          </v-flex-->


          <v-flex xs12 class="headline font-weight-regular text-left">
               {{currentJsonFile.title}}
          </v-flex>

          <v-flex xs12 class="title font-weight-light text-left">
              COURSE NUMBER: {{currentJsonFile.id}}
              <p></p>
          </v-flex>

        <v-flex xs12>
          <v-dialog  scrollable fullscreen hide-overlay transition="dialog-bottom-transition"
            v-model="scheduleDialog"
          >

            <template v-slot:activator="{ on }" v-if="isScheduleAvailable">
              <v-btn
                color="primary"
                dark
                v-on="on"
              >
                See schedule
              </v-btn>
            </template>

            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="scheduleDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Available dates</v-toolbar-title>
              </v-toolbar>
              
              <template v-if="(filteredSchedule.length > 0)">
                <v-simple-table fixed-header>
                  <thead>
                    <tr>
                      <th class="text-left">Dates</th>
                      <th class="text-left">Location</th>
                      <th class="text-left">SO #</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in filteredSchedule" :key="item.id">
                      <td><span v-if="(item.start == item.end)">{{formatDate(item.start)}}</span><span v-else>{{formatDate(item.start)}} - {{formatDate(item.end)}}</span></td>
                      <td><b> {{locationFullName(item.loc)}}</b></td>
                      <td>{{item.id}}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
                </template>

                <v-spacer></v-spacer>

                <v-card-text v-if="(filteredSchedule.length == 0)">
                  <v-layout justify-center wrap>
                    <p class="display-1 text--primary text-center">
                        No dates available
                    </p>
                  </v-layout>
                </v-card-text>

            </v-card>
          </v-dialog>

          <template v-if="currentJsonFile.eLMS">
            <p></p>
              <v-btn :href="currentJsonFile.eLMS" target="_blank" color="orange">More information (eLMS)</v-btn>
          </template>
        </v-flex>
          
        <!--template v-if="isAuthenticated"  class="text-xs-left">
            <form @submit.prevent>
            <v-layout row>
              <v-flex xs5>
        
                <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                > <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="date"
                    label="Select training date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" 
                    :allowed-dates="allowedDates"
                    min="2019-05-15"
                    :event-color="date => date[9] % 2 ? 'green' : 'yellow'"
                    :events="functionEvents"
                    @input="menu = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs5>
                <v-btn color="success" @click="addThisCourse">Register</v-btn>
              </v-flex>
           </v-layout>
         </form>
        </template>

	      <template v-else  class="text-xs-left">
           <v-layout row>
              <v-flex xs12>
                 <v-btn color="primary" to="/signup">SIGN UP to REGISTER</v-btn>
              </v-flex>
           </v-layout>
        </template-->



      <v-flex xs12 sm6 class="text-left">
          <h4>DESCRIPTION AND LEARNING STRATEGY</h4>
            <template v-for="(descParagraph,index) in currentJsonFile.description">
              <p :key="index">{{descParagraph}}</p>
            </template>

          <h4>OBJECTIVES</h4>
          <ul id="course-objectives">
            <li v-for="item in currentJsonFile.objectives" :key="item">
               {{ item }}
            </li>
          </ul>
      </v-flex>

      <template v-if="currentJsonFile.capabilities && currentJsonFile.capabilities.length > 0">
      <v-flex xs12 sm6 class="text-center">
            <h4>STRATEGIC LEADERSHIP CAPABILITIES</h4>
            <v-layout row wrap>
                <v-flex xs6 v-for="item in strLeadCap" v-bind:key="item.id">
                    <v-card dark color="indigo darken-4" v-if="capIncluded(item.id)" @click="openSLC(item.id)">
                        <v-card-text>{{item.text}}</v-card-text>
                    </v-card>
                    <v-card dark color="blue-grey lighten-4" v-else>
                        <v-card-text>{{item.text}}</v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <p></p>

          <template v-if="currentJsonFile.competencies && currentJsonFile.competencies.length > 0">
            <h4>MANAGERIAL SUCCESS COMPETENCIES</h4>
            <v-layout row wrap>
                <template v-for="item in strCompetencies">
                  <v-flex xs12 md6 class="text-left" v-if="compIncluded(item.id)" v-bind:key="item.id">
                      • {{item.text}}
                  </v-flex>
                </template>
            </v-layout>
            <p></p>
          </template>

          <template v-if="currentJsonFile.topics">
            <h4>SESSION TOPICS</h4>
            <v-layout row wrap>
                <template v-for="item in strTopics">
                  <v-flex xs12 md6 class="text-left" v-if="topicIncluded(item.id)" v-bind:key="item.id">
                      • {{item.text}}
                  </v-flex>
                </template>
            </v-layout>
            <p></p>
          </template>
      </v-flex>
      </template>

      <v-divider></v-divider>

      <v-flex xs12 sm6 class="text-xs-left">

          <template v-if="currentJsonFile.class_size && currentJsonFile.class_size != ''">
            <h4>CLASS SIZE <span class="font-weight-light">{{currentJsonFile.class_size}}</span></h4>
            <br/>
          </template>

          <h4>FORMAT <span class="font-weight-light">{{currentJsonFile.format}}</span></h4>
          <br/>

          <template v-if="currentJsonFile.length && currentJsonFile.length != ''">
            <h4>LENGTH <span class="font-weight-light">{{currentJsonFile.length}}</span></h4>
            <br/>
          </template>

          <template v-if="currentJsonFile.who_should_attend && currentJsonFile.who_should_attend != ''">
            <h4>WHO SHOULD ATTEND?</h4>
            <p>{{currentJsonFile.who_should_attend}}</p>
          </template>

      </v-flex>


      <v-flex xs12 sm6 class="text-xs-left">
          <h4>PREREQUISITES</h4>
          <p v-if="currentJsonFile.prerequisites.text == '' && currentJsonFile.prerequisites.list.length == 0">None</p>
          <p v-if="currentJsonFile.prerequisites.text != ''">{{currentJsonFile.prerequisites.text}}</p>
          <template v-if="currentJsonFile.prerequisites.list.length > 0">
            <ul v-for="(item,index) in currentJsonFile.prerequisites.list">
              <li :key="index">{{item}}</li>
            </ul>
          </template>

          <p></p>

          <template v-if="currentJsonFile.assessment && currentJsonFile.assessment != ''">
            <h4>ASSESSMENT</h4>
            <p>{{currentJsonFile.assessment}}</p>
          </template>

          <h4>RELATED COURSES</h4>
          <template v-if="currentJsonFile.related_courses.length > 0">
            <ul id="related-course">
              <li v-for="item in currentJsonFile.related_courses" :key="item">
               {{ item }}
              </li>
            </ul>
          </template>
          <p v-else>None</p>

      </v-flex>



        </v-layout>
    </v-container>

    <v-container fluid  fill-height v-else>

        <v-layout wrap>
        <v-flex xs12>
           <v-alert type="error">
                There is no data for this course. Please try again later!
           </v-alert>
        </v-flex>

              <v-flex xs12 text-center>
                <v-btn @click="$router.go(-1)" color="info">Back</v-btn>
              </v-flex>
        </v-layout>


    </v-container>

</template>


<script>
import moment from 'moment';
import scheduleJson from '@/json/course_schedule.json'
import locationsJson from '@/json/training_locations.json'
const fb = require('../firebaseConfig.js')

export default {
  props: ['id'],
  data () {
    return {
      scheduleDialog: false,
      scheduleData: scheduleJson,
      trainingLocations: locationsJson,
      dataExists: false,
      alert1: false,
      alert2: false,
      date: "",
      menu: false,
      modal: false,
      strLeadCap: [
        {id: "FOM", text: "Focusing on Mission"},
        {id: "DO", text: "Developing Others"},
        {id: "VDAI", text: "Valuing Diversity and Inclusion"},
        {id: "EI", text: "Encouraging Innovation"},
        {id: "CE", text: "Communicating Effectively"},
        {id: "WC", text: "Working Collaboratively"},
        {id: "LWI", text: "Leading with Influence"},
        {id: "DA", text: "Demonstrating Accountability"}
        ],
      strCompetencies: [
        {id: "AM", text: "Accountability and Measurement"},
        {id: "A", text: "Agility"},
        {id: "BA", text: "Building Alliances"},
        {id: "BMP", text: "Building a Model EEO Program"},
        {id: "BTC", text: "Building Teamwork and Cooperation"},
        {id: "BA1", text: "Business Acumen"},
        {id: "C", text: "Communication"},
        {id: "CR", text: "Conflict Resolution"},
        {id: "CF", text: "Customer Focus"},
        {id: "DM", text: "Decision-Making"},
        {id: "DT", text: "Developing Talent"},
        {id: "I", text: "Innovation"},
        {id: "IH", text: "Integrity and Honesty"},
        {id: "IRI", text: "Interpersonal Relations and Influence"},
        {id: "MOP", text: "Managing Organizational Performance"},
        {id: "PS", text: "Problem-Solving"},
        {id: "SF", text: "Strategy Formulation"},
        {id: "TC", text: "Teamwork and Collaboration"},
        {id: "V", text: "Vision"}
        ],
      strTopics: [
        {id: "LS", text: "Leadership Styles"},
        {id: "SLC", text: "Strategic Leadership Capabilities"},
        {id: "ID", text: "Individual Development"},
        {id: "OC", text: "Organizational Climate"},
        {id: "IC", text: "Interpersonal Communications"},
        {id: "I", text: "Influencing"},
        {id: "OTD", text: "Organizational and Team Development"},
        {id: "C", text: "Collaboration"},
        {id: "A", text: "Accountability"},
        {id: "EE", text: "Employee Engagement"},
        {id: "AP", text: "Action Plans"}
        ]
    }
  },
  computed: {
    filteredSchedule () {
      let normalizedSearch = this.id.toLowerCase()
      return this.scheduleData.filter(datum => Object.values(datum).some(cid => 
            String(cid).toLowerCase().includes(normalizedSearch)))
    },
    isScheduleAvailable () {
      return (this.filteredSchedule.length > 0)
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    signedInUserId () {
      return this.$store.getters.signedInUserId
    },
    error () {
      return this.$store.state.error
    },
    message () {
      return this.$store.state.message
    }
  },
  methods: {
    openSLC(slcID) {
        this.$router.push({ path: '/slc#' + slcID })
    },
    locationFullName (locId) {

      let location = this.trainingLocations.filter(item => item.locationId.includes(locId))

      try
      {
        return location[0].title
      }catch(e)
      {
        return locId
      }        
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YY")
      }
      return ""
    },
    allowedDates() {
        return ["21","23","25","30","31"]
    },
    functionEvents (date) {
        const [,, day] = date.split('-')
        if ([12, 17, 28].includes(parseInt(day, 10))) return true
        if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', '#00f']
        return false
    },
    todayDate () {
        const toTwoDigits = num => num < 10 ? '0' + num : num;
        let today = new Date()
        let year = today.getFullYear()
        let month = toTwoDigits(today.getMonth() + 1)
        let day = toTwoDigits(today.getDate())
        return `${year}-${month}-${day}`
    },
    getJsonFile (courseId) {
      try
      {
        this.currentJsonFile = require('../json/courses/' + courseId + '.json')
        this.dataExists = true

      }catch(e)
      {
        this.dataExists = false
      }
    },
    capIncluded(capId) {
      try
      {
        return this.currentJsonFile.capabilities.includes(capId)
      }catch(e)
      {
        return false
      }
    },
    compIncluded(compId) {
      try
      {
        return this.currentJsonFile.competencies.includes(compId)
      }catch(e)
      {
        return false
      }
    },
    topicIncluded(topicId) {
      try
      {
        return this.currentJsonFile.topics.includes(topicId)
      }catch(e)
      {
        return false
      }
    },
    addThisCourse () {

        this.alert2 = false

        if( this.date != '' )
        {
            fb.myCoursesCollection.add({
                    desired_date: this.date,
                    courseid: this.id,
                    status: 0,
                    userid: this.signedInUserId,
                    title: this.currentJsonFile.title
             }).then(ref => {

                    this.$store.commit('appendToMyCourses', {
                        docId: ref.id,
                        desired_date: this.date,
                        status: 0,
                        courseid: this.id,
                        userid: this.signedInUserId,
                        title: this.currentJsonFile.title})

                    this.$store.commit('setMessage', 'Course was added to your list!')


             }).catch(err => {
                    this.$store.commit('setError', err)
             })

        }else
        {
            this.$store.commit('setError', 'Please select the date!')
        }

    }
  },
  created: function () {
    this.getJsonFile(this.id);
  },
  mounted: function () {
    this.getJsonFile(this.id);
  },
  watch: {
    error (value) {
      if (value) {
        this.alert2 = true
      }
    },
    alert2 (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    },
    message (value) {
      if (value) {
        this.alert1 = true
      }
    },
    alert1 (value) {
      if (!value) {
        this.$store.commit('setMessage', null)
      }
    }
  }
}
</script>

<style>
</style>
